import { ACCOUNTS } from "./accounts";
import { PAYMENTS } from "./payments";
import { TREASURY } from "./treasury";
import { OPERATIONS } from "./operations";
import { DEVELOPERS } from "./developers";

export const PLATFORM_PRODUCTS = [
  ...ACCOUNTS,
  ...PAYMENTS,
  ...TREASURY,
  ...OPERATIONS,
  ...DEVELOPERS,
];

// Ordered categories for the overview page
export const PLATFORM_CATEGORIES = [
  {
    name: "Konten & Identität",
    description: "Konten, IBANs und Identität als programmierbares Fundament.",
    products: ACCOUNTS,
  },
  {
    name: "Zahlungen",
    description: "Ein- und ausgehende Zahlungsflüsse über eine Engine.",
    products: PAYMENTS,
  },
  {
    name: "Karten & Treasury",
    description: "Karten ausgeben, Liquidität steuern, Währungen wechseln.",
    products: TREASURY,
  },
  {
    name: "Finanzoperationen",
    description: "Rechnungen und Buchhaltung mit dem Ledger als Wahrheit.",
    products: OPERATIONS,
  },
  {
    name: "Entwickler",
    description: "APIs und Events für die vollständige Kontrolle im Code.",
    products: DEVELOPERS,
  },
];

export function getProductBySlug(slug) {
  return PLATFORM_PRODUCTS.find((p) => p.slug === slug);
}

export function getRelatedProducts(product) {
  if (!product?.related) return [];
  return product.related
    .map((slug) => getProductBySlug(slug))
    .filter(Boolean);
}
